<template>
  <div class="bannerSwiper">
    <!-- @onSlideChangeEnd="onSlideChangeEnd" -->
    <swiperCpt
      class="bannerswiperCpt wow fadeInUp animated"
      ref="indexBannerSwiper"
      :delay="5000"
      :loop="resBanners.length > 1 ? true : false"
      :autoplay="resBanners.length > 1 ? true : false"
      sid="indexBannerSwiper"
      v-if="isShow"
    >
      <div
        class="swiper-slide"
        v-for="(item, index) in resBanners"
        :key="index"
      >
        <div
          class="banner"
          :class="[
            activeIndex == index ? 'fadeInUp animationDelay animated' : '',
          ]"
        >
          <img :src="item.src" ref="imgH" />
          <div
            v-if="item.isShowTips"
            :class="[
              activeIndex == index ? 'fadeInLeft animationDelay animated' : '',
              'txtsmbg',
            ]"
          >
            <!-- 线 -->
            <i class="unLine"></i>
            <!-- 圆 -->
            <i class="round"></i>
            <div class="txtCN">{{ item.txtCN }}</div>
            <div class="txtEN">{{ item.txtEN }}</div>
            <div class="iconlist">
              <div
                class="i_item"
                v-for="(iconItem, index) in item.list"
                :key="iconItem.text + index"
              >
                <div class="icon">
                  <img :src="iconItem.imgsrc" :alt="iconItem.text" />
                </div>
                <div class="text">{{ iconItem.text }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </swiperCpt>
    <div
      class="swiperBtn swiperBtn_left"
      @click="$refs.indexBannerSwiper.swiperSl.swipePrev()"
    ></div>
    <div
      class="swiperBtn swiperBtn_right"
      @click="$refs.indexBannerSwiper.swiperSl.swipeNext()"
    ></div>
  </div>
</template>

<script>
import $ from "jquery.1";
import swiperCpt from "@/components/common/swiperCpt.vue";
import "swiper/dist/idangerous.swiper.css";
if (process.browser) {
  var { WOW } = require("wowjs");
}
export default {
  components: { swiperCpt },
  data() {
    return {
      isShow: false,
      activeIndex: 0,
      resBanners: [
        // {
        //   src: require("../../assets/images/index/banner1.jpg"),
        //   // txtCN: "创林化药业之先   造万民健康之福",
        //   // txtEN: "WUZHOU HUANGPU CHEMICAL  PHARMACEUTICAL CO. LTD",
        //   // isShowTips:true,
        //   // list: [
        //   //   {
        //   //     imgsrc: require("../../assets/images/index/anquan.png"),
        //   //     text: "安全",
        //   //   },
        //   //   {
        //   //     imgsrc: require("../../assets/images/index/chuangxin.png"),
        //   //     text: "创新",
        //   //   },
        //   //   {
        //   //     imgsrc: require("../../assets/images/index/zhuanye.png"),
        //   //     text: "专业",
        //   //   },
        //   // ],
        // },
      ],
    };
  },
  mounted() {
    this.getDataList();
    this.isShow = true;
    if (process.browser) {
      new WOW({
        live: false,
        offset: 0,
      }).init();
    }
    // this.imgLoad();
    window.addEventListener("resize", this.imgLoad, false);
  },
  methods: {
    onSlideChangeEnd(swiper) {
      $(".swiper-slide")
        .find(".banner")
        .removeClass("fadeInUp animationDelay animated");
      $(".swiper-slide")
        .find(".txtsmbg")
        .removeClass("fadeInLeft animationDelay animated");
      $(".swiper-slide-active")
        .find(".banner")
        .addClass("fadeInUp animationDelay animated");
      $(".swiper-slide-active")
        .find(".txtsmbg")
        .addClass("fadeInLeft animationDelay animated");
      // console.log(swiper.activeLoopIndex, '轮播图', this.activeIndex)
    },
    imgLoad() {
      this.$nextTick(() => {
        this.imgHeight = `${this.$refs.imgH[0].height}px`;
      });
    },
    async getDataList() {
      let res = await this.$request.getImageAdvertisingList({
        advertisingPosition: "0",
      });
      if (res.code === 200) {
        let resBanners = [];
        let tipsList = [
          {
            imgsrc: require("../../assets/images/index/anquan.png"),
            text: "安全",
          },
          {
            imgsrc: require("../../assets/images/index/chuangxin.png"),
            text: "创新",
          },
          {
            imgsrc: require("../../assets/images/index/zhuanye.png"),
            text: "专业",
          },
        ];
        res.rows.map((item, index) => {
          let retainfield = item.retainfield1
            ? item.retainfield1.split("；")
            : "";
          resBanners.push({
            src: this.$store.state.baseUrl + item.imageUrl,
            isShowTips: !!retainfield,
            txtCN: retainfield ? retainfield[0] : "",
            txtEN: retainfield ? retainfield[1] : "",
            list: [
              tipsList[item.label1 ? item.label1 - 0 : 0],
              tipsList[item.label2 ? item.label2 - 0 : 1],
              tipsList[item.label3 ? item.label3 - 0 : 2],
            ],
          });
        });
        // console.log(res.rows);
        this.resBanners = resBanners;
        this.$nextTick(() => {
          this.isShow = true;
          this.$refs.indexBannerSwiper.swiperSl.reInit();
        });
      }
    },
  },
  // destroyed() {
  //   // window.removeEventListener("resize", this.imgLoad, false);
  // },
};
</script>

<style lang="scss" scoped>
$LiWidth: 60px;
$unLineBackgroundColor: #ffffff;
.bannerSwiper,
.bannerSwiper .bannerswiperCpt {
  width: 100%;
}
.bannerSwiper {
  position: relative;
  .swiperBtn {
    width: 40px;
    height: 70px;
    cursor: pointer;
    position: absolute;
    top: 50%;
    margin-top: -35px;
    z-index: 66;
    &.swiperBtn_left {
      left: 0;
      background: rgba($color: #c2c3be, $alpha: 0.5)
        url("../../assets/images/common/btn_left.png");
      background-size: cover;
      &:hover {
        background: rgba($color: #fff, $alpha: 0.5)
          url("../../assets/images/common/btn_left.png");
        background-size: cover;
      }
    }
    &.swiperBtn_right {
      right: 16px;
      background: rgba($color: #c2c3be, $alpha: 0.5)
        url("../../assets/images/common/btn_right.png");
      background-size: cover;
      &:hover {
        background: rgba($color: #fff, $alpha: 0.5)
          url("../../assets/images/common/btn_right.png");
        background-size: cover;
      }
    }
  }
}
.txtsmbg {
  display: block;
  width: 30.42vw;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 555;
  box-sizing: border-box;
  padding: 13.02vw 2.08vw 0;
  margin-left: -36.46vw;
  background: #7ebb15;
  &.fadeInLeft {
    .txtCN {
      opacity: 1;
      transform: translate(0, 0);
    }
    .txtEN {
      opacity: 1;
      transform: translate(0, 0);
    }
    .iconlist {
      opacity: 1;
      transform: translate(0, 0);
    }
  }
  .unLine {
    display: flex;
    width: $LiWidth;
    height: 0.21vw;
    box-sizing: border-box;
    position: absolute;
    top: 5.21vw;
    left: 2.08vw;
    &::before {
      content: "";
      display: block;
      width: 0.42vw;
      height: 0.21vw;
      border-radius: 0.26vw;
      background: $unLineBackgroundColor;
    }
    &::after {
      content: "";
      flex: 1;
      height: 0.21vw;
      border-radius: 0.26vw;
      background: $unLineBackgroundColor;
      margin-left: 0.21vw;
    }
  }
  .round {
    display: block;
    width: 3.13vw;
    height: 3.13vw;
    position: absolute;
    top: 3.33vw;
    right: 2.08vw;
    &::after {
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-color: #f7f7f7;
      opacity: 0.5;
    }
    &::before {
      content: "";
      display: block;
      width: 1.56vw;
      height: 1.56vw;
      border-radius: 50%;
      background-color: #ffffff;
      opacity: 0.23;
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -0.78vw 0 0 -0.78vw;
    }
  }
  .txtCN {
    font-size: 1.77vw;
    line-height: 2.34vw;
    color: #ffffff;
    padding-bottom: 3.13vw;
    transition: 0.6s all;
    transition-delay: 0.6s;
    opacity: 0;
    transform: translate(-100%, 0);
  }
  .txtEN {
    font-size: 1.04vw;
    line-height: 2.6vw;
    letter-spacing: 0.16vw;
    color: #ffffff;
    padding-bottom: 5.21vw;
    transition: 0.6s all;
    transition-delay: 1s;
    opacity: 0;
    transform: translate(-100%, 0);
  }
  .iconlist {
    width: 100%;
    transition: 0.6s all;
    transition-delay: 1.4s;
    opacity: 0;
    transform: translate(-100%, 0);
    .i_item {
      float: left;
      width: 33%;
      display: flex;
      .icon {
        display: inline-block;
        img {
          display: inline-block;
          width: 1.56vw;
        }
      }
      .text {
        display: inline-block;
        font-size: 1.04vw;
        line-height: 1.56vw;
        color: #ffffff;
        padding-left: 0.52vw;
      }
    }
  }
}

@media (min-width: 1920px) {
  .txtsmbg {
    display: block;
    width: 584px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 555;
    box-sizing: border-box;
    padding: 250px 40px 0;
    margin-left: -700px;
    background: #7ebb15;
    .unLine {
      display: flex;
      width: $LiWidth;
      height: 4px;
      box-sizing: border-box;
      position: absolute;
      top: 100px;
      left: 40px;
      &::before {
        content: "";
        display: block;
        width: 8px;
        height: 4px;
        border-radius: 5px;
        background: $unLineBackgroundColor;
      }
      &::after {
        content: "";
        flex: 1;
        height: 4px;
        border-radius: 5px;
        background: $unLineBackgroundColor;
        margin-left: 4px;
      }
    }
    .round {
      display: block;
      width: 60px;
      height: 60px;
      position: absolute;
      top: 64px;
      right: 40px;
      &::after {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: #f7f7f7;
        opacity: 0.5;
      }
      &::before {
        content: "";
        display: block;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #ffffff;
        opacity: 0.23;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -15px 0 0 -15px;
      }
    }
    .txtCN {
      font-size: 34px;
      line-height: 45px;
      color: #ffffff;
      padding-bottom: 60px;
    }
    .txtEN {
      font-size: 20px;
      line-height: 50px;
      letter-spacing: 3px;
      color: #ffffff;
      padding-bottom: 100px;
    }
    .iconlist {
      width: 100%;
      .i_item {
        float: left;
        width: 33%;
        display: flex;
        .icon {
          display: inline-block;
          img {
            display: inline-block;
            width: 30px;
          }
        }
        .text {
          display: inline-block;
          font-size: 20px;
          line-height: 30px;
          color: #ffffff;
          padding-left: 10px;
        }
      }
    }
  }
}
</style>